'use client';

import { Box } from '@/primitives';
import NewsSection from './NewsSection';
import { LandingAlternatingFeatures } from './LandingAlternatingFeatures';
import { LandingComingSoon } from './LandingComingSoon';
import { LandingClosingCta } from './LandingClosingCta';
import { LandingGetStarted } from './LandingGetStarted';
import { LandingFeatureGrid } from './LandingFeatureGrid';
import { LandingHero } from './LandingHero';
import { LandingTrustStrip } from './LandingTrustStrip';

export default function HomeLanding() {
  return (
    <Box component="article" sx={{ width: '100%' }}>
      <LandingHero />
      <LandingTrustStrip />
      <LandingFeatureGrid />
      <LandingGetStarted />
      <LandingAlternatingFeatures />
      <LandingComingSoon />
      <LandingClosingCta />
      <NewsSection />
    </Box>
  );
}
